/* What's in the box (Oct 20). Every safe ships with free extras, and each one is a real $0 cart line, so the cart,
   checkout, order and emails list them with their own pictures. The rules come from snippets/bs-included (shop metafield
   boostedsafe.included_map): which freebies each safe gets, and how many safes a multi-safe variant counts as.

   The cart's freebie lines always equal what its safes include. Nobody can raise, lower or remove one by hand:
   - every cart request on the page (add, change, update, clear) is followed by a sync before the caller sees the
     response, so a redirect to the cart or a redrawn section already shows the right freebies;
   - a page that renders with the counts wrong (snippets/bs-included sets "ok") syncs on load and redraws;
   - checkout waits for one last sync.
   Freebie rows render without a quantity box or a remove button (sections/main-cart-items). */
(function () {
  var el = document.getElementById('bs-included');
  if (!el || window.bsIncluded) return;
  var data; try { data = JSON.parse(el.textContent); } catch (e) { return; }
  var map = data.map; if (!map || !map.order) return;
  window.bsIncluded = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  /* a freebie line is any line of a freebie product (any variant), the same identity the Liquid check uses */
  var byProduct = {};
  map.order.forEach(function (k) { byProduct[map.freebies[k].product] = k; });
  var keyOf = function (it) { return byProduct[it.product_id]; };

  var json = function (url, body) {
    return nativeFetch(root + url, { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body ? JSON.stringify(body) : undefined })
      .then(function (r) { if (!r.ok) throw r; return r.json(); });
  };

  /* what to change so the freebie lines match the safes: one line per freebie, at the safes' count */
  var plan = function (cart) {
    var want = {}, lines = {}, updates = {}, adds = [];
    map.order.forEach(function (k) { want[k] = 0; lines[k] = []; });
    cart.items.forEach(function (it) {
      var k = keyOf(it);
      if (k) { lines[k].push(it); return; }
      var rule = map.safes[String(it.product_id)]; if (!rule) return;
      var n = (rule.per_variant && rule.per_variant[String(it.variant_id)]) || 1;
      rule.keys.forEach(function (key) { if (key in want) want[key] += it.quantity * n; });
    });
    map.order.forEach(function (k) {
      var ls = lines[k];
      if (!ls.length) { if (want[k] > 0) adds.push({ id: map.freebies[k].variant, quantity: want[k] }); return; }
      if (ls[0].quantity !== want[k]) updates[ls[0].key] = want[k];
      ls.slice(1).forEach(function (l) { updates[l.key] = 0; });
    });
    return { updates: updates, adds: adds };
  };

  /* one sync at a time; a call made while one runs waits for it, then runs its own fresh pass, so a cart change that
     landed mid-sync is never answered with the earlier result */
  var running = null;
  var sync = function () {
    if (running) return running.catch(function () {}).then(function () { return sync(); });
    var changed = false, passes = 0;
    var step = function () {
      return json('cart.js').then(function (cart) {
        var p = plan(cart), hasUpdates = Object.keys(p.updates).length > 0;
        /* three passes is plenty; the cap only stops a loop if the store ever refuses a line */
        if ((!hasUpdates && !p.adds.length) || ++passes > 3) return cart;
        changed = true;
        return (hasUpdates ? json('cart/update.js', { updates: p.updates }) : Promise.resolve())
          .then(function () { return p.adds.length ? json('cart/add.js', { items: p.adds }) : null; })
          .then(step);
      });
    };
    running = step().then(function (cart) { running = null; counts(cart); return { cart: cart, changed: changed }; },
      function (e) { running = null; throw e; });
    return running;
  };

  /* the cart bubble counts what you bought, not the freebies */
  var counts = function (cart) {
    var extras = 0;
    cart.items.forEach(function (it) { if (keyOf(it)) extras += it.quantity; });
    var n = cart.item_count - extras;
    document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function (s) { s.textContent = n; });
  };

  /* the sections a cart request asked Shopify to render, so they can be redrawn after the sync */
  var sectionsOf = function (init) {
    var b = init && init.body, s = null;
    if (!b) return null;
    if (typeof b === 'string') { try { s = JSON.parse(b).sections; } catch (e) { return null; } }
    else if (typeof FormData !== 'undefined' && b instanceof FormData) s = b.get('sections');
    if (!s) return null;
    return Array.isArray(s) ? s.join(',') : String(s);
  };

  var CART = /\/cart\/(add|change|update|clear)(\.js)?\/?(\?|$)/;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var req = nativeFetch(input, init);
    if (!CART.test(url.split('#')[0])) return req;
    return req.then(function (res) {
      if (!res.ok) return res;
      return res.clone().text().then(function (txt) {
        return sync().then(function (r) {
          if (!r.changed) return res;
          var body; try { body = JSON.parse(txt); } catch (e) { return res; }
          if (body && typeof body === 'object' && 'item_count' in body) body.item_count = r.cart.item_count;
          var secs = sectionsOf(init);
          /* the caller's error checks read body.items, which still match its own request; only the drawn sections
             (and the count) need to reflect the synced cart */
          var redraw = secs && body && body.sections
            ? nativeFetch(location.pathname + '?sections=' + encodeURIComponent(secs)).then(function (x) { return x.json(); }).then(function (s) { body.sections = s; })
            : Promise.resolve();
          return redraw.then(function () {
            return new Response(JSON.stringify(body), { status: res.status, statusText: res.statusText, headers: res.headers });
          });
        }).catch(function () { return res; });
      }, function () { return res; });
    });
  };

  /* a page drawn with the wrong freebies (an add from another tab, a form post without script, an edited cart) */
  var redraw = function () {
    var items = document.querySelector('cart-items');
    if (items && typeof items.onCartUpdate === 'function') { items.onCartUpdate(); return; }
    if (!document.querySelector('cart-items')) return;
    var last = 0; try { last = +sessionStorage.getItem('bsInclFix') || 0; } catch (e) {}
    if (Date.now() - last < 15000) return;
    try { sessionStorage.setItem('bsInclFix', Date.now()); } catch (e) {}
    location.reload();
  };
  var onLoad = function () {
    if (data.ok) return;
    document.documentElement.classList.add('bs-incl-sync');
    sync().then(function (r) { if (r.changed) redraw(); }).catch(function () {})
      .then(function () { document.documentElement.classList.remove('bs-incl-sync'); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onLoad); else onLoad();

  /* the free-items card folds on phones (snippets/bs-included-rows); delegated, so a redrawn cart keeps working */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-bs-incl-toggle]'); if (!b) return;
    var card = b.closest('[data-bs-incl-card]'), open = !card.classList.contains('open');
    card.classList.toggle('open', open); b.setAttribute('aria-expanded', String(open));
  });

  /* checkout (and the cart form's own update) waits for one last sync */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !/\/cart\/?$/.test((f.getAttribute('action') || '').split('?')[0]) || f.bsIncluded) return;
    e.preventDefault();
    var btn = e.submitter;
    sync().catch(function () {}).then(function () {
      f.bsIncluded = true;
      if (btn && btn.name) { var h = document.createElement('input'); h.type = 'hidden'; h.name = btn.name; h.value = btn.value || ''; f.appendChild(h); }
      f.submit();
    });
  }, true);
})();
